import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AttributeComponent } from '../../interfaces/attribute.component';
import { AttributeDefinition } from '../../models/attribute-definition';
import { FormControl, FormGroup } from '@angular/forms';
import { AttributeControlService } from '../../attribute-control-service';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit, AttributeComponent {
  @Input() formGroup: FormGroup;
  @Input() attributeDefinition: AttributeDefinition;

  @Output() onRemove = new EventEmitter<number>();

  constructor(
    public _attributeControlService: AttributeControlService<boolean>
  ) { }

  get label(): string {
    return (this.attributeDefinition?.name || '').replace(/\s*[:*]+$/, '').trim();
  }

  get control(): FormControl {
    return this.formGroup.get(this.attributeDefinition.formControlName) as FormControl;
  }

  ngOnInit() {
    this._attributeControlService.addFormControl(this.attributeDefinition.formControlName, this.attributeDefinition.isRequired, !!this.attributeDefinition.value, this.formGroup);
  }

  value(): boolean {
    this.attributeDefinition.value = this._attributeControlService.getValue(this.attributeDefinition.formControlName, this.formGroup);
    return this.attributeDefinition.value == true;
  }

  ngOnDestroy(): void {
    this._attributeControlService.removeControl(this.attributeDefinition.formControlName, this.formGroup);
  }
}
